module.exports = __webpack_public_path__ + "img/productFea2.bc379ed8.png";